import { c as _c } from "react/compiler-runtime";
import WifiOffIcon from '@mui/icons-material/WifiOff';
import type { SxProps } from '@mui/material';
export const WifiOff = t0 => {
  const $ = _c(2);
  const {
    styles
  } = t0;
  let t1;
  if ($[0] !== styles) {
    t1 = <WifiOffIcon sx={{
      ...styles
    }} />;
    $[0] = styles;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};